import React from 'react';
import './Contractjob.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const Textcoldescribe2 = () => {
    return(
        <>
        <Container>
            <Row className='textrow'>
                    <Col sm={12} className='textcol'>
                        <h4>Align Skills with Opportunities</h4>
                        <p>Our advanced matching program, developed through years of industry expertise, will match you
                        to the right job, ensuring your career growth and stability, regardless of your level of experience.</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
} 

export default Textcoldescribe2